<div class="row">
  <div class="col-md-12 text-center">
    <h1 class="text-jumbo text-ginormous">Oops! We can't seem to find the page you're looking for.</h1>
    <h6>Error code: 404</h6>
  </div>
</div>
